import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Button from "@/components/button.vue"
  import {onUnmounted, ref, useTemplateRef} from "vue"
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'foldable_content',
  props: {
    image: {
      default: null,
      required: false,
      type: String
    },
    title: {
      default: null,
      required: true,
      type: String
    }
  },
  setup(__props) {

  
  
  onUnmounted(() => {
    removeEventListener("click", outsideClick)
  })
  
  const component = useTemplateRef("component")
  const visible = ref<boolean>(false)
  
  function outsideClick() {
    if (component.value.matches(":hover")) {
      return
    }
    toggle()
  }
  
  function toggle() {
    if (visible.value) {
      visible.value = false
      removeEventListener("click", outsideClick)
    } else {
      visible.value = true
      addEventListener("click", outsideClick)
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "component",
        ref: component,
        class: "foldable-content"
      }, [
        _createVNode(Button, {
          image: __props.image,
          title: __props.title,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle()))
        }, null, 8, ["image", "title"]),
        _createElementVNode("div", {
          class: _normalizeClass(["content", [visible.value ? 'visible' : null]])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 512)
    ]),
    _: 3
  }))
}
}

})